/* tslint:disable */
import { PipeLineElmt } from './pipe-line-elmt';

/**
 */
export class ViewPipeLineElmt {
    mine?: PipeLineElmt[];
    others?: PipeLineElmt[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-pipe-line-elmt.ts